import { firebaseUploadFile } from '../firebase';

const saveAvatarFile = item => {
    return dispatch => {
        return dispatch(firebaseUploadFile({ refId: item.id, file: item.image, rootFolder: 'avatars', folder: '' }));
    };
};

export default saveAvatarFile;
